import LeadsTableContainer from './LeadsTableContainer.component';

export default LeadsTableContainer;